import React, { useContext } from "react";
import Accordion from "@mui/material/Accordion";
import AccordionSummary from "@mui/material/AccordionSummary";
import AccordionDetails from "@mui/material/AccordionDetails";
import Typography from "@mui/material/Typography";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
// import Box from "@mui/material/Box";
import Card from "@mui/material/Card";
// import CardActions from "@mui/material/CardActions";
import CardContent from "@mui/material/CardContent";
// import Button from "@mui/material/Button";
import { Grid } from "@mui/material";
import Divider from "@mui/material/Divider";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import { themeCtx } from "../../utils/hooks/themeContext";

function ProjectCard(props) {
  const [expanded, setExpanded] = React.useState("panel1");
  const moment = require("moment");
  const { t } = useTranslation();
  const theme = useTheme();
  const { currentTheme } = useContext(themeCtx);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  const utcDate = new Date(props.createdAt);

  const localTime = new Date(utcDate.getTime() - +props.timeZone * 60000);

  return (
    <Card
      sx={{
        minWidth: 275,
        backgroundColor: theme.palette.secondary.main,
        mx: { md: "20%" },
      }}
    >
      <Grid container justifyContent="space-between">
        <Grid md={4}>
          <CardContent>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {t("createproject.projectname")}
            </Typography>
            <Typography variant="h4" component="div">
              {props.projectName}
            </Typography>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {t("createproject.projectId")}
            </Typography>
            <Typography variant="body1" component="div">
              {props.number}
            </Typography>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {t("createproject.location")}
            </Typography>
            <Typography variant="body1">
              {(props.address != "" ? props.address + ", " : "") +
                props.city +
                ", " +
                props.country}
            </Typography>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {t("createproject.elevation")}
            </Typography>
            <Typography>{props.elevation} m</Typography>
            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              {t("createproject.createdAt")}
            </Typography>
            <Typography variant="body1" component="div">
              {moment(localTime).format("DD/MM/YYYY HH:mm:ss")}
            </Typography>

            <Typography
              sx={{ fontSize: 14 }}
              color="text.secondary"
              gutterBottom
            >
              Price
            </Typography>
            <Typography variant="body1" component="div">
              {props.totalCosts.toFixed(2)} €
            </Typography>
          </CardContent>
        </Grid>
        <Grid xs mt={2} mx={2} mb={1}>
          <Accordion
            expanded={expanded === "panel1"}
            onChange={handleChange("panel1")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel1a-content"
              id="panel1a-header"
            >
              <Typography> {t("createproject.summer")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction="row">
                <Grid item xs>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.dryBulbTemperatureCelsius")}
                  </Typography>
                  <Typography>{props.summerOutdoorTemperature} °C</Typography>

                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.wetBulbTemperatureCelsius")}
                  </Typography>
                  <Typography>{props.summerWetBulbTemperature} °C</Typography>
                </Grid>

                <Divider orientation="vertical" flexItem />

                <Grid item xs>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.dewPointTemperatureCelsius")}
                  </Typography>
                  <Typography>{props.summerDewPointTemperature} °C</Typography>

                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.relativeHumiditySummer")}
                  </Typography>
                  <Typography>{props.summerOutdoorHumidity} %</Typography>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel2"}
            onChange={handleChange("panel2")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>{t("createproject.winter")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Grid container direction="row">
                <Grid item xs>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.heatingDB")}
                  </Typography>
                  <Typography>{props.winterOutdoorTemperature} °C</Typography>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.humidityRatio")}
                  </Typography>
                  <Typography>{props.winterOutdoorHumidityRatio} %</Typography>
                </Grid>
                <Grid item xs>
                  <Typography
                    sx={{ fontSize: 14 }}
                    color="text.secondary"
                    gutterBottom
                  >
                    {t("createproject.relativeHumidityWinter")}
                  </Typography>
                  <Typography>{props.winterOutdoorHumidity} %</Typography>
                </Grid>
              </Grid>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel3"}
            onChange={handleChange("panel3")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography>{t("createproject.utilityrates")} </Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                {t("createproject.electricity")}
              </Typography>
              <Typography>{props.elPriceBusiness} €/kWh</Typography>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                {t("createproject.electricityhome")}
              </Typography>
              <Typography>{props.elPriceHome} €/kWh</Typography>
            </AccordionDetails>
          </Accordion>
          <Accordion
            expanded={expanded === "panel4"}
            onChange={handleChange("panel4")}
          >
            <AccordionSummary
              expandIcon={<ExpandMoreIcon />}
              aria-controls="panel2a-content"
              id="panel2a-header"
            >
              <Typography> {t("createproject.airquality")}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                {t("createproject.aqi")}
              </Typography>
              <Typography>{props.aqiCurrent}</Typography>
              <Typography
                sx={{ fontSize: 14 }}
                color="text.secondary"
                gutterBottom
              >
                {t("createproject.aqiAvg")}
              </Typography>
              <Typography>{props.aqiYearlyAverage}</Typography>
            </AccordionDetails>
          </Accordion>
          {currentTheme && (
            <Accordion
              expanded={expanded === "panel5"}
              onChange={handleChange("panel5")}
            >
              <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel5a-content"
                id="panel5a-header"
              >
                <Typography> {t("customer.sectionTitle")}</Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Grid container direction="row">
                  <Grid item xs>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {t("customer.ERPId")}
                    </Typography>
                    <Typography>{props.erpId} </Typography>

                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {t("customer.customerName")}
                    </Typography>
                    <Typography>{props.customerName} </Typography>
                  </Grid>

                  <Divider orientation="vertical" flexItem />

                  <Grid item xs>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {t("customer.customerRepresentative")}
                    </Typography>
                    <Typography>{props.customerRepresentative} </Typography>

                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {t("customer.customerPhone")}
                    </Typography>
                    <Typography>{props.customerPhone} </Typography>
                    <Typography
                      sx={{ fontSize: 14 }}
                      color="text.secondary"
                      gutterBottom
                    >
                      {t("customer.customerEmail")}
                    </Typography>
                    <Typography>{props.customerEmail}</Typography>
                  </Grid>
                </Grid>
              </AccordionDetails>
            </Accordion>
          )}
        </Grid>
      </Grid>
    </Card>
  );
}

export default ProjectCard;
